import { FunctionComponent } from "react";

export interface Props {
  className?: string;
  width?: number;
  height?: number;
}

const CaretDownIcon: FunctionComponent<Props> = ({
  className,
  width = 13,
  height = 8,
}) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 13 8"
      fill="currentColor"
    >
      <path
        fillRule="evenodd"
        d="M12.357 1.179 6.179 7.357 0 1.179 1.179 0l5 5 5-5 1.178 1.179Z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export default CaretDownIcon;
